/**
 * @generated SignedSource<<e1b39fe83ab1783fb361fccb1f179efd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedHeroCarousel_componentModule$data = {
  readonly title: string | null;
  readonly viewMoreLink: string | null;
  readonly " $fragmentType": "HpSharedHeroCarousel_componentModule";
};
export type HpSharedHeroCarousel_componentModule$key = {
  readonly " $data"?: HpSharedHeroCarousel_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedHeroCarousel_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedHeroCarousel_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewMoreLink",
      "storageKey": null
    }
  ],
  "type": "HeroModule",
  "abstractKey": null
};

(node as any).hash = "81963ada15b1e7a565c66338ddf64270";

export default node;
